/* tslint:disable */

import { ConcreteRequest } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type routes_Signup_QueryVariables = {};
export type routes_Signup_QueryResponse = {
    readonly viewer: {
        readonly isAnonymous: boolean | null;
        readonly " $fragmentRefs": FragmentRefs<"SignUp_viewer">;
    } | null;
};
export type routes_Signup_Query = {
    readonly response: routes_Signup_QueryResponse;
    readonly variables: routes_Signup_QueryVariables;
};



/*
query routes_Signup_Query {
  viewer {
    isAnonymous
    ...SignUp_viewer
    id
  }
}

fragment SignUp_viewer on Viewer {
  id
  username
}
*/

const node: ConcreteRequest = (function(){
var v0 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "isAnonymous",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "routes_Signup_Query",
    "type": "RootQuery",
    "metadata": null,
    "argumentDefinitions": [],
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "Viewer",
        "plural": false,
        "selections": [
          (v0/*: any*/),
          {
            "kind": "FragmentSpread",
            "name": "SignUp_viewer",
            "args": null
          }
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "routes_Signup_Query",
    "argumentDefinitions": [],
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "Viewer",
        "plural": false,
        "selections": [
          (v0/*: any*/),
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "id",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "username",
            "args": null,
            "storageKey": null
          }
        ]
      }
    ]
  },
  "params": {
    "operationKind": "query",
    "name": "routes_Signup_Query",
    "id": null,
    "text": "query routes_Signup_Query {\n  viewer {\n    isAnonymous\n    ...SignUp_viewer\n    id\n  }\n}\n\nfragment SignUp_viewer on Viewer {\n  id\n  username\n}\n",
    "metadata": {}
  }
};
})();
(node as any).hash = 'e31d7e656a55acbe389c9df3f1261b79';
export default node;
